/* RESPONSIBLE TEAM: team-workflows */

import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class AttributeDescriptorListOptionSerializer extends EmbercomBaseSerializer {
  attrs = {
    descriptor: { serialize: false },
  };
}
